import { render, staticRenderFns } from "./ModuleImageGalleryForm.vue?vue&type=template&id=bf5ec79c&scoped=true"
import script from "./ModuleImageGalleryForm.vue?vue&type=script&lang=js"
export * from "./ModuleImageGalleryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5ec79c",
  null
  
)

export default component.exports